<ion-header>
  <ion-toolbar color="primary">
    <!-- <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons> -->
    <ion-title>{{ 'ONAM' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="selectLanguage()">
        <ion-icon name="language"></ion-icon>
        <!-- <span class="ion-padding">{{ 'APP.BUTTON.Language' | translate }}</span> -->
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="login-content">
  <ion-row class="ion-text-center">
    <ion-col offset="4" size="4" offset-md="5" size-md="2">
        <app-image-shell class="" animation="spinner" [src]="'./assets/images/logo/logo.png'"></app-image-shell>
    </ion-col>
  </ion-row>
  <ion-row class="ion-text-center">
    <ion-col size="12">
      <h3 class="ion-no-padding">{{ 'APP.LOGIN.Login' | translate }}</h3>
      <p class="ion-no-padding">{{ 'APP.LOGIN.LoginMessage' | translate }}</p>
    </ion-col>
  </ion-row>
  <ion-row class="ion-text-center">
    <ion-col size="12" size-md="8" offset-md="2">
      <form [formGroup]="loginForm" (ngSubmit)="doLogin(loginForm.value)">
        <ion-list class="inputs-list" lines="full">
          <ion-item class="input-item">
            <ion-input type="email" placeholder="Email" formControlName="email" autocapitalize="off" inputmode="email"></ion-input>
            <ion-icon class="show-option" name="mail-outline"></ion-icon>
          </ion-item>
          <div class="error-container">
            <ng-container *ngFor="let validation of validation_messages.email">
              <div class="error-message" *ngIf="loginForm.get('email').hasError(validation.type) && (loginForm.get('email').dirty || loginForm.get('email').touched)">
                <span>{{ validation.message | translate }}</span>
              </div>
            </ng-container>
          </div>

          <ion-item class="input-item">
            <app-show-hide-password>
              <ion-input type="password" placeholder="Password" formControlName="password"></ion-input>
            </app-show-hide-password>
          </ion-item>
          <div class="error-container">
            <ng-container *ngFor="let validation of validation_messages.password">
              <div class="error-message" *ngIf="loginForm.get('password').hasError(validation.type) && (loginForm.get('password').dirty || loginForm.get('password').touched)">
                <span>{{ validation.message | translate }}</span>
              </div>
            </ng-container>
          </div>
        </ion-list>
        <div class="text-center" *ngIf="errorCode">
          <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{ 'APP.MESSAGE.LOGIN.login_' + errorCode | translate }}</div>
        </div>
        <div class="text-center" *ngIf="!errorCode">
          <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{ 'APP.MESSAGE.ERROR.Default' | translate }}</div>
        </div>

        <ion-button class="login-btn" type="submit" expand="block" [disabled]="!loginForm.valid">{{ 'APP.LOGIN.Login' | translate }}</ion-button>

        <ion-list class="inputs-list border-top my-3" lines="full"></ion-list>
        <ion-list class="inputs-list" lines="full">
          <ion-button class="forgot-btn" fill="clear" [routerLink]="['/auth/forgot-password']">
            {{ 'APP.LOGIN.ForgotPassword' | translate }}
          </ion-button>
        </ion-list>
        <ion-list class="inputs-list border-top my-3" lines="full"></ion-list>
        <ion-list class="inputs-list" lines="full">
          <div class="text-center mb-3">
            <div class="" [innerHTML]="'APP.MESSAGE.Signup-hint' | translate"></div>
          </div>  
          <ion-button color="light" type="button" class="signup-btn-" expand="block" [routerLink]="['/auth/signup']">
            {{ 'APP.LOGIN.SignUp' | translate }}
          </ion-button>
        </ion-list>
      </form>
    </ion-col>
    <ion-col size="12" size-md="8" offset-md="2">
      <div class="small text-right mt-3">
        <span (click)="reloadApp()">v. {{ version }}</span>
      </div>
    </ion-col>
</ion-row>

  <!-- <div class="social-auth-options">
    <p class="options-divider">Or</p>
    <ion-button class="social-auth-btn facebook-auth-btn" expand="block" color="facebook" (click)="doFacebookLogin()">Log In with Facebook</ion-button>
    <ion-button class="social-auth-btn google-auth-btn" expand="block" color="google" (click)="doGoogleLogin()">Log In with Google</ion-button>
    <ion-button class="social-auth-btn twitter-auth-btn" expand="block" color="twitter" (click)="doTwitterLogin()">Log In with Twitter</ion-button>
    <ion-button class="social-auth-btn apple-auth-btn" expand="block" color="dark" (click)="doAppleLogin()">Log In with Apple</ion-button>
  </div> -->
</ion-content>
